import React from 'react';

const loader = () => {
    return (
        <div className="no-freeze-spinner">
        <div id="no-freeze-spinner">
            <div>
            <i className="material-icons">
                account_circle
            </i>
            <i className="material-icons">
                home
            </i>
            <i className="material-icons">
                work
            </i>
            <div>
            </div>
            </div>
        </div>
        </div>
    );
};

export default loader;